
/* styles */
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-rewriter?id=data-v-2008b19c!../node_modules/vue-loader/lib/selector?type=styles&index=0!./CommentList.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./CommentList.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-2008b19c!../node_modules/vue-loader/lib/selector?type=template&index=0!./CommentList.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/CommentList.vue
// module id = 22
// module chunks = 0